// ── Logical space (scaled to viewport each frame, DPR ≤ 2) ──
export const W = 440;
export const H = 640;

export const R = 20;             // bubble radius
export const D = R * 2;          // diameter / grid step
export const EVEN_COLS = 11;     // wide rows (effective parity 0)
export const ODD_COLS = 10;      // narrow rows (effective parity 1)
export const ROW_H = D * Math.sqrt(3) / 2;  // ≈ 34.64, hex vertical packing

export const DEATH_LINE_Y = 540;
export const LAUNCHER_X = W / 2; // 220
export const LAUNCHER_Y = 596;

export const DROP_INTERVAL = 8;  // shots between ceiling drops
export const SHOT_SPEED = 900;   // logical units / second
export const NUM_COLORS = 6;
export const START_ROWS = 5;

export const AIM_MIN = 15 * Math.PI / 180;
export const AIM_MAX = 165 * Math.PI / 180;

export const BEST_KEY = 'game-bubble-shooter-best';

export type Color = number;      // 0..NUM_COLORS-1

export interface Bubble {
  row: number;
  col: number;
  color: Color;
}

export interface Projectile {
  x: number;
  y: number;
  vx: number;
  vy: number;
  color: Color;
}

export type Phase = 'menu' | 'playing' | 'win' | 'lost';

export interface GameState {
  bubbles: Map<string, Bubble>;   // key = "row,col"
  dropCount: number;              // ceiling drops so far → effective parity offset
  dropCounter: number;            // shots remaining until next ceiling drop
  current: Color;                 // loaded in launcher
  next: Color;                    // preview
  projectile: Projectile | null;
  aimAngle: number;               // radians, measured from +x axis (π/2 = straight up)
  score: number;
  best: number;
  phase: Phase;
}

// ── Transient visual effects (live outside GameState) ──
export type Effect =
  | { kind: 'pop'; x: number; y: number; color: Color; startMs: number; dur: number }
  | { kind: 'fall'; x: number; y: number; vy: number; color: Color; startMs: number; dur: number }
  | { kind: 'snap'; x: number; y: number; color: Color; startMs: number; dur: number }
  | { kind: 'particle'; x: number; y: number; vx: number; vy: number; r: number; color: Color; startMs: number; dur: number };

export interface Button { x: number; y: number; w: number; h: number; }

export interface Layout {
  scale: number;   // logical → device px
  ox: number;      // x offset (letterbox)
  oy: number;
  W: number;       // device css px of canvas
  H: number;
}

export interface Theme {
  bgTop: string; bgBottom: string;
  wall: string; danger: string;
  text: string; textDim: string; accent: string;
  overlayBg: string; btnBg: string; btnText: string;
  balls: string[];  // length NUM_COLORS
}
